import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../utils';
import { FormFlex, FormFlexItem, FormGrid, FormGridItem } from '../FormGrid';
import { Icon } from '../Icon';
const TitleStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
}));
const IconImageStyled = styled('div')(({ theme }) => ({
    height: theme.spacing(6),
    width: theme.spacing(6),
    borderRadius: '50%',
    backgroundColor: theme.palette.secondary.contrastText,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
const FormGridStyled = styled(FormGrid, {
    shouldForwardProp: (prop) => prop !== 'gapBottom',
    name: 'FormGridStyled',
})(({ theme, gapBottom }) => ({
    marginBottom: theme.spacing(gapBottom ? 2 : 0),
}));
const FormFlexStyled = styled(FormFlex)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(0.5),
    },
}));
export const DataTableRowHeader = ({ icon, image, title, action, tags, description, editable = false, rowGap = 2, gapBottom = false, }) => (_jsxs(FormGridStyled, { rowGap: rowGap, columnGap: 1, gapBottom: gapBottom, children: [_jsx(FormGridItem, { endDecorator: false, children: _jsxs(FormFlexStyled, { rowGap: 2, columnGap: 1, justifyContent: "space-between", align: "center", flexWrap: "inherit", flexGrow: 0, children: [_jsxs(TitleStyled, { children: [((icon && !image) || (image && !icon)) && (_jsxs(IconImageStyled, { children: [icon && !image && _jsx(Icon, { variant: icon }), image && !icon && _jsx(_Fragment, { children: image })] })), title] }), (tags || (action && editable)) && (_jsxs(FormFlexItem, { width: "auto", children: [tags && _jsx(_Fragment, { children: tags }), action && editable && _jsx(_Fragment, { children: action })] }))] }) }), description && (_jsx(FormGridItem, { endDecorator: false, children: _jsx(_Fragment, { children: description }) }))] }));
